import { render, staticRenderFns } from "./AccordionElement.vue?vue&type=template&id=6baa19d9"
import script from "./AccordionElement.vue?vue&type=script&lang=js"
export * from "./AccordionElement.vue?vue&type=script&lang=js"
import style0 from "./AccordionElement.vue?vue&type=style&index=0&id=6baa19d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports